import * as THREE from 'three'
import { crtPosterShaderStable,crtPosterShaderMoving} from './shaders.js'


export default class PlaneManager {

    constructor() {
        this.planes = [];
        this.paths = ['MP.jpeg','K.jpeg','BB2.jpeg','ME.jpeg','MP.jpeg','MP.jpeg'];
        this.texs = {};
        this.fallbacktex = new THREE.MeshBasicMaterial({color: 0xff00ff})
        
        this.paths.forEach((path,index) => {
            const tex = new THREE.TextureLoader().load(`./texture/img/${path}`,(tex) => {
                tex.minFilter = THREE.LinearFilter;
                tex.magFilter = THREE.LinearFilter;
                tex.generateMipmaps = false;
                this.texs[index] = tex;
                if(Object.keys(this.texs).length === this.paths.length) {
                    console.log('All CRT textures loaded');
                    this.addMatTooPlanes();
                }
            });
        });
    }
    addMatTooPlanes() {
        this.planes.forEach( (planeObj) => {
            if(planeObj.useStatic) planeObj.plane.material = this.addStaticCRTMat(planeObj.idx1,color);
            else planeObj.plane.material = this.addMovingCRTMat(planeObj.idx1,planeObj.idx2,planeObj.color);
        });
    }

    addMovingCRTMat(idx1 = 2,indx2 = 3,color = true) {
        if(!this.texs[idx1] || !this.texs[indx2]) {
            return this.fallbacktex;
        }

        return new THREE.ShaderMaterial({
        side: THREE.FrontSide,      // helps if plane is facing away
        transparent: false,          // alpha is 1 anyway
        blending: THREE.AdditiveBlending, // optional CRT glow
        uniforms: {
            mapA:         { value: this.texs[idx1] },
            mapB:         { value: this.texs[indx2] },
            time:        { value: 0 },
            resolution:  { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
            stripeWidth: { value: 10.0 },  // tweak 2–6
            dotHeight:   { value: 6.0 },  // tweak 2–6
            glowColor:   { value: color? new THREE.Color(0xcc33ff): new THREE.Color(0x33ffcc) },
            uvRotation: { value: Math.PI * 1.5 },                      // set after plane rotation
            uBloomIntensity: { value: 3.0 },
        },
        vertexShader: crtPosterShaderMoving.vertexShader,
        fragmentShader: crtPosterShaderMoving.fragmentShader
    });
    }
    addStaticCRTMat(idx1 = 0,color = true) {
        if(!this.texs[idx1] ) {
            return this.fallbacktex;
        }
        return new THREE.ShaderMaterial({
        side: THREE.FrontSide,      // helps if plane is facing away
        transparent: true,          // alpha is 1 anyway
        blending: THREE.AdditiveBlending, // optional CRT glow
        uniforms: {
            map:         { value: this.texs[idx1] },
            time:        { value: 0 },
            resolution:  { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
            stripeWidth: { value: 10.0 },  // tweak 2–6
            dotHeight:   { value: 6.0 },  // tweak 2–6
            glowColor:   { value: color? new THREE.Color(0xcc33ff): new THREE.Color(0x33ffcc) },
            uvRotation: { value: Math.PI * 0.5 },                      // set after plane rotation
        },
        vertexShader: crtPosterShaderStable.vertexShader,
        fragmentShader: crtPosterShaderStable.fragmentShader
    });
    }
    addPlane(plane,idx1 = 0,idx2 = 1,color = true,useStatic = false) {
        this.planes.push({plane: plane,idx1: idx1,idx2: idx2,color: color,useStatic: useStatic,material: null});
    }
}
